import React from "react";

const ITEMS = [
  "Education Changes Lives",
  "Honoring His Imperial Majesty",
  "Empowering Ethiopia's Youth",
  "Legacy · Education · Opportunity · Service",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-gold/20 bg-ink2 py-6"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="mx-8 font-serif text-2xl sm:text-3xl font-light text-ivory2/70">
            {t}
            <span className="mx-8 text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
